var map = {
	"./1/symbol_0.png": "0016",
	"./1/symbol_1.png": "ad22",
	"./1/symbol_10.png": "f20c",
	"./1/symbol_11.png": "dffd",
	"./1/symbol_12.png": "419d",
	"./1/symbol_2.png": "7c0c",
	"./1/symbol_3.png": "4191",
	"./1/symbol_4.png": "15b0",
	"./1/symbol_5.png": "2dd9",
	"./1/symbol_6.png": "c142",
	"./1/symbol_7.png": "2df0",
	"./1/symbol_8.png": "5ba7",
	"./1/symbol_9.png": "0bff",
	"./2/symbol_0.png": "69fc",
	"./2/symbol_1.png": "f1dc",
	"./2/symbol_10.png": "93b7",
	"./2/symbol_11.png": "d3c9",
	"./2/symbol_12.png": "e197",
	"./2/symbol_2.png": "e67f",
	"./2/symbol_3.png": "858c",
	"./2/symbol_4.png": "b08d",
	"./2/symbol_5.png": "5351",
	"./2/symbol_6.png": "fd9f",
	"./2/symbol_7.png": "1617",
	"./2/symbol_8.png": "e7ea",
	"./2/symbol_9.png": "7554f",
	"./3/symbol_0.png": "b569",
	"./3/symbol_1.png": "0404",
	"./3/symbol_10.png": "6084",
	"./3/symbol_12.png": "37c3",
	"./3/symbol_2.png": "7796",
	"./3/symbol_3.png": "ff33",
	"./3/symbol_4.png": "e7405",
	"./3/symbol_5.png": "4b29",
	"./3/symbol_6.png": "c640",
	"./3/symbol_7.png": "4208",
	"./3/symbol_8.png": "d0b5",
	"./3/symbol_9.png": "b30a",
	"./4/symbol_0.png": "8e78",
	"./4/symbol_1.png": "a3cac",
	"./4/symbol_10.png": "85e2",
	"./4/symbol_12.png": "0b7b",
	"./4/symbol_2.png": "1ce9",
	"./4/symbol_3.png": "482c",
	"./4/symbol_4.png": "6337",
	"./4/symbol_5.png": "2274",
	"./4/symbol_6.png": "c96a",
	"./4/symbol_7.png": "f689",
	"./4/symbol_8.png": "bcf4",
	"./4/symbol_9.png": "4b4f",
	"./gamble/btn_HIGH_lose.png": "b0cc",
	"./gamble/btn_HIGH_normal.png": "8ac3",
	"./gamble/btn_HIGH_win.png": "1cdc",
	"./gamble/btn_LOW_lose.png": "fadc",
	"./gamble/btn_LOW_normal.png": "6ad7",
	"./gamble/btn_LOW_win.png": "c0a4",
	"./gamble/btn_collect.png": "4032",
	"./gamble/history_lose.png": "7b99",
	"./gamble/history_win.png": "2686",
	"./gamble/wheel_HIGH_lose.png": "cd42",
	"./gamble/wheel_HIGH_win.png": "f0c6",
	"./gamble/wheel_LOW_lose.png": "320f",
	"./gamble/wheel_LOW_win.png": "599b",
	"./gold1.png": "2859",
	"./gold2.png": "0b76",
	"./gold3.png": "173b",
	"./gold4.png": "6041",
	"./header_slotmachine_freespin._no_fg.png": "8eb8",
	"./silver1.png": "b675",
	"./silver2.png": "d3a5",
	"./silver3.png": "719a",
	"./silver4.png": "1d90",
	"./slotmachine.png": "3aa87"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5000";